var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { ref: "root", staticClass: "slider-group" }, [
    !_setup.isMobile
      ? _c(
          "button",
          {
            staticClass: "slider-group__button slider-group__button_prev",
            class: {
              "slider-group__button_hidden": !_setup.slider?.isLeftArrowVisible,
            },
            on: { click: _setup.handleClickPrev },
          },
          [
            _c("span", {
              staticClass:
                "ui-icon-fz-medium ui-icon-arrow-left icon-secondary--text",
            }),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c("div", {
      staticClass: "slider-group__fog slider-group__fog_left",
      class: {
        "slider-group__fog_visible":
          _vm.fog &&
          _vm.fog !== "right" &&
          !_setup.slider?.isFullyScrolledToLeft &&
          _setup.slider?.hasUserInteracted,
      },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "slider-group__slider" }, [
      _c(
        "div",
        {
          ref: "container",
          staticClass: "slider-group__container d-flex align-end",
          style: {
            "padding-left": `${_vm.paddingLeft ?? _vm.paddingX ?? 0}px`,
            "padding-right": `${_vm.paddingRight ?? _vm.paddingX ?? 0}px`,
          },
        },
        _vm._l(_vm.items, function (item, itemIndex) {
          return _c(
            "div",
            {
              key: itemIndex,
              ref: "sliderItemRefs",
              refInFor: true,
              staticClass: "slider-group__item",
              class: {
                "mr-2": itemIndex < _vm.items.length - 1,
              },
              on: {
                click: function ($event) {
                  return _setup.handleClickItem($event, itemIndex)
                },
              },
            },
            [
              _vm._t("default", null, null, {
                item,
                index: itemIndex,
                onClick: _setup.onClick,
              }),
            ],
            2
          )
        }),
        0
      ),
    ]),
    _vm._v(" "),
    _c("div", {
      staticClass: "slider-group__fog slider-group__fog_right",
      class: {
        "slider-group__fog_visible":
          _vm.fog &&
          _vm.fog !== "left" &&
          !_setup.slider?.isFullyScrolledToRight,
      },
    }),
    _vm._v(" "),
    !_setup.isMobile
      ? _c(
          "button",
          {
            staticClass: "slider-group__button slider-group__button_next",
            class: {
              "slider-group__button_hidden":
                !_setup.slider?.isRightArrowVisible,
            },
            on: { click: _setup.handleClickNext },
          },
          [
            _c("span", {
              staticClass:
                "ui-icon-fz-medium ui-icon-arrow-right icon-secondary--text",
            }),
          ]
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }